const AUTH_TOKEN_KEY = 'auth-token';
const THEME_KEY = 'theme';
const ACTIVE_VIEW = 'active-view';

export { AUTH_TOKEN_KEY, THEME_KEY, ACTIVE_VIEW };
